module.exports = __webpack_public_path__ + "nl-sena-page-6ac1d77f512993797d80.png";